






















































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    computed: {
        ...mapGetters({
            userCurrentTicket: 'UserTickets/getUserCurrentTicket',
        }),
    },
})
export default class PreviewTicketConversation extends Mixins(
    DateMethods,
    InputFieldMethods,
) {
    public userNewMessageText: string = '';

    constructor() {
        super();
    }

    get getUserId() {
        return this.$store.getters['User/getUserId'];
    }

    get closingTarget(): string {
        return this.$store.getters['UserTickets/getTicketChatOpenTarget'];
    }

    public cancel() {
        this.$store.commit(Mutations.SET_PREVIEW_TICKET_CONVERSATION_VISIBILITY, false);
        this.$store.commit(Mutations.SET_USER_TICKET_CONVERSATION, []);
    }

    get userTicketConversation() {
        return this.$store.getters['UserTickets/getUserTicketConversation'];
    }

    public returnUsernameFirstLetter(name: string)  {
        return name.charAt(0).toUpperCase();
    }

    public userSendNewMessage(conversationId: number)  {
        if (this.userNewMessageText === '') {
            return false;
        }
        this.$store.dispatch(Actions.SEND_TICKET_MESSAGE_TO_ADMIN, { conversationId, text: this.userNewMessageText });
        this.userNewMessageText = '';
        this.setInputFieldHeight(false, true);
    }

    public created() {
        this.userNewMessageText = '';
        const currentTicket = this.$store.getters['UserTickets/getUserCurrentTicket'];
        this.$store.dispatch(Actions.FETCH_USER_TICKET_CONVERSATION, currentTicket.conversation.id);
    }

    public mounted() {
        this.textInputElement = (this.$refs['message-text'] as HTMLTextAreaElement);
    }

    public beforeDestroy() {
        const currentTicket = this.$store.getters['UserTickets/getUserCurrentTicket'];
        this.$store.commit(Mutations.RESET_TICKET_UNREAD_COUNT, currentTicket.id);
    }
}
